import { toast } from "react-toastify/dist";
import { BASE_URL } from "../../../global";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";

export const getDiscipline = async () => {
  let url = BASE_URL;
  try {
    const response = await axiosWithToken.get(
      url + "discipline?_where=(status,eq,1)"
    );
    return response.data;
  } catch (error) {
    if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong while fetching disciplines!");
          }
    throw error;
  }
};

export const getUnitMasterArray = async () => {
  let url = BASE_URL;
  try {
    const response = await axiosWithToken.get(
      url + "unit?_where=(status,eq,1)"
    );
    return response.data;
  } catch (error) {
    if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong while fetching units!");
          }
    throw error;
  }
};

export const getRanges = async (paramsId, page, rowsPerPage) => {
  if(!paramsId) return;
  try {
    const totalCountQuery = {
      query: `select count(*) as no_of_rows from standardRanges where standardId = ${paramsId} and status = 1`,
    };
    const totalCountResponse = await axiosWithToken.post(BASE_URL + `dynamic`, totalCountQuery);
    const totalCount = totalCountResponse.data[0]?.no_of_rows;

    const standardRangesQuery = {
      query: `select * from standardRanges where standardId = ${paramsId} and status = 1 order by id limit ${rowsPerPage} offset ${page * rowsPerPage}`,
    };
    const standardRangesResponse = await axiosWithToken.post(BASE_URL + `dynamic`, standardRangesQuery);
    const standardRanges = standardRangesResponse.data;

    return { totalCount, standardRanges };
  } catch (error) {
    if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong while fetching standardRanges!");
          }
    throw error;
  }
};

export const getStandard = (
  paramsId,
  unitArray,
  standardDetails,
  setStandardDetails,
  createSrfObject,
  setDeciplines,
  setUnits,
  setDisciplineID,
  setDateIsSave,
) => {
  let url = BASE_URL;

  axiosWithToken
    .get(
      url +
        `xjoin?_join=ds.standards,_j,disciplines.discipline,&_on1=(ds.disciplineId,eq,disciplines.id)&_fields=ds.location,ds.materialType,ds.masterrange,ds.masterUncertainty,ds.masteraccuracy,ds.masterleastcount,ds.standardName,ds.type,ds.make,ds.id,ds.certificateUrl,ds.traceability,ds.validUpto,ds.id,ds.certificateNumber,disciplines.name,ds.model,ds.serialNo,ds.stId,ds.calDate,disciplines.id,disciplines.disciplineKey&_where=(ds.id,eq,${paramsId})~and(ds.status,ne,-1)`
    )
    .then((res) => {
      setDateIsSave({
        calDateissave: res.data[0]?.ds_calDate ? true : false,
        dueDateissave: res.data[0]?.ds_validUpto ? true : false,
      });
      setStandardDetails({
        ...standardDetails,
        standardName: res.data[0]?.ds_standardName || "",
        ids: res.data[0]?.ds_stId || "",
        serialNo: res.data[0]?.ds_serialNo || "",
        make: res.data[0]?.ds_make || "",
        model: res.data[0]?.ds_model || "",
        location: res.data[0]?.ds_location || "",
        calDate: res.data[0]?.ds_calDate || "",
        validUpto: res.data[0]?.ds_validUpto || "",
        traceability: res.data[0]?.ds_traceability || "",
        certificateNumber: res.data[0]?.ds_certificateNumber || "",
        EQMType: res.data[0]?.ds_type || "",
        materialType: res.data[0]?.ds_materialType || "",
        certificateUrl: res.data[0]?.ds_certificateUrl || "",
      });
      let dataObject = res.data[0];
      let newData = {
        masterrange: dataObject.ds_masterrange,
        masteraccuracy: dataObject.ds_masteraccuracy,
        masterleastcount: dataObject.ds_masterleastcount,
        masterUncertainty: dataObject.ds_masterUncertainty,
      };
      dataObject && createSrfObject(newData);

      setDeciplines(
        res.data[0]?.disciplines_id + ", " + res.data[0]?.disciplines_name
      );

      if (res.data[0]?.disciplines_disciplineKey == "0") {
        setDisciplineID(0);
      } else if (res.data[0]?.disciplines_disciplineKey == "1") {
        setDisciplineID(1);
      } else if (res.data[0]?.disciplines_disciplineKey == "2") {
        setDisciplineID(2);
      } else if (res.data[0]?.disciplines_disciplineKey == "3") {
        setDisciplineID(3);
      } else if (res.data[0]?.disciplines_disciplineKey == "4") {
        setDisciplineID(4);
      }


      const unitArr = [""];
      for (let i = 0; i < unitArray?.length; i++) {
        if (
          parseInt(res.data[0]?.disciplines_id) == unitArray[i]?.disciplineId
        ) {
          unitArr.push(unitArray[i]);
        }
      }
      setUnits(unitArr);
    })
    .catch((error) => {
      console.log(error);
      if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong with standards!");
          }
    });
};